import { Loading } from "./loading";
export * from "./loading";
export * from "./loading-listener";
export var LOADING_DIRECTIVES = [
    Loading
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/loading/index.js
// module id = 213
// module chunks = 4